module.exports = __webpack_public_path__ + "media/images/portal/i-4-9db2e97f14da689bdeb91ffea6b6c856.png";